export default __webpack_public_path__ + "static/media/image 9.35aa4b46.svg";